import React, { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import useAppLevelAuth from "../hooks/useAppLevelAuth";
import "./LayoutNavbar.scss";
import NewHeader from "./NewHeader";
import NewSidebar from "./NewSidebar";

export default function LayoutNavbar({ children }) {
  const { isLoggedIn } = useAppLevelAuth();
  const location = useLocation();
  const pathname = location.pathname;

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [userRole, setUserRole] = useState("user");
  const [menuSearchTerm, setMenuSearchTerm] = useState("");
  const [hasInitializedLayout, setHasInitializedLayout] = useState(false);

  useEffect(() => {
    if (isLoggedIn) {
      // import("@/entities/User").then(({ User }) => {
      //   User.me().then((user) => {
      //     if (user) setUserRole(user.role || "user");
      //   });
      // });
      // Mock user role for now
      setUserRole("admin");
    }
  }, [isLoggedIn]);

  // ✅ Responsive behavior (IDENTIK)
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile((prevIsMobile) => {
        // React only when crossing mobile/desktop breakpoint.
        if (prevIsMobile !== mobile) {
          setIsSidebarOpen(!mobile);
        }
        return mobile;
      });

      if (!hasInitializedLayout) {
        setIsSidebarOpen(!mobile);
        setHasInitializedLayout(true);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ✅ Close sidebar on route change (IDENTIK)
  useEffect(() => {
    if (isMobile) {
      setIsSidebarOpen(false);
    }
  }, [isMobile]);

  const toggleSidebar = useCallback(() => setIsSidebarOpen((prev) => !prev), []);

  if (!isLoggedIn) {
    return <main className="layout-main-full">{children}</main>;
  }

  // ✅ Margin logic IDENTIK
  const mainClass = `layout-main ${
    isMobile ? "ml-0" : isSidebarOpen ? "ml-260" : "ml-80"
  }`;

  return (
    <div className="layout-container">
      <NewHeader
        onToggleSidebar={toggleSidebar}
        searchTerm={menuSearchTerm}
        onSearchChange={setMenuSearchTerm}
      />

      <NewSidebar
        isOpen={isSidebarOpen}
        isMobile={isMobile}
        onCloseMobile={() => setIsSidebarOpen(false)}
        onExpand={() => setIsSidebarOpen(true)}
        userRole={userRole}
        searchTerm={menuSearchTerm}
      />

      <main className={mainClass}>
        <div className="layout-content">{children}</div>
      </main>
    </div>
  );
}
// "use client";

// import React, { useState, useEffect } from "react";
// import { usePathname } from "next/navigation";
// import useAppLevelAuth from "@/hooks/useAppLevelAuth";
// import './LayoutNavbar.scss';
// import NewHeader from "./NewHeader";
// import NewSidebar from "./NewSidebar";

// export default function LayoutNavbar({ children }) {
//   const { isLoggedIn } = useAppLevelAuth();
//   const [isSidebarOpen, setIsSidebarOpen] = useState(true);
//   const [isMobile, setIsMobile] = useState(false);
//   const [userRole, setUserRole] = useState("user");
//   const pathname = usePathname();

//   useEffect(() => {
//     if (isLoggedIn) {
//       import("@/entities/User").then(({ User }) => {
//         User.me().then((user) => {
//           if (user) setUserRole(user.role || "user");
//         });
//       });
//     }
//   }, [isLoggedIn]);

//   // Responsive behavior (IDENTIK)
//   useEffect(() => {
//     const handleResize = () => {
//       const mobile = window.innerWidth < 1024;
//       setIsMobile(mobile);

//       if (mobile) {
//         setIsSidebarOpen(false);
//       } else {
//         setIsSidebarOpen(true);
//       }
//     };

//     handleResize();

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // Close sidebar on route change (IDENTIK)
//   useEffect(() => {
//     if (isMobile) {
//       setIsSidebarOpen(false);
//     }
//   }, [pathname, isMobile]);

//   const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

//   if (!isLoggedIn) {
//     return <main className="layout-main-full">{children}</main>;
//   }

//   // Margin logic IDENTIK
//   const mainClass = `layout-main ${
//     isMobile
//       ? "ml-0"
//       : isSidebarOpen
//       ? "ml-260"
//       : "ml-80"
//   }`;

//   return (
//     <div className="layout-container">
//       <NewHeader onToggleSidebar={toggleSidebar} />

//       <NewSidebar
//         isOpen={isSidebarOpen}
//         isMobile={isMobile}
//         onCloseMobile={() => setIsSidebarOpen(false)}
//         userRole={userRole}
//       />

//       <main className={mainClass}>
//         <div className="layout-content">{children}</div>
//       </main>
//     </div>
//   );
// }